import IconMenuImport from 'components/Icons/IconMenu/MenuIcon.svg?react';

export const IconMenu = IconMenuImport;
